// extracted by mini-css-extract-plugin
export default {"content":"BlockImage_content__SN1J5","block":"BlockImage_block__2KCke","image":"BlockImage_image__9oyoH","text":"BlockImage_text__qEWDg","blockImage":"BlockImage_blockImage__f5rFM"};